var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-Handlers---On-Shift---02",
    transform: "translate(-1227.000000, -389.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1212.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2363864,72.2757414 C23.9956364,72.8189353 22.9201818,73 21.4519318,73 C18.0192273,73 15,70.6061822 15,66.663826 C15,62.5604716 18.0812727,59 22.7340455,59 C26.3944091,59 29,61.4339507 29,64.8132021 C29,67.7701248 27.30425,69.6205931 25.0709318,69.6205931 C24.0990455,69.6205931 23.3960227,69.1176876 23.2924545,68.0717436 L23.2510909,68.0717436 C22.5892727,69.0775547 21.6794318,69.6205931 20.5627727,69.6205931 C19.2392955,69.6205931 18.2467273,68.6350041 18.2467273,66.9856668 C18.2467273,64.5115832 20.1286136,62.29883 23.1063182,62.29883 C24.0161591,62.29883 25.0500909,62.5201831 25.5464545,62.7816691 L24.9261591,66.5230497 C24.7400227,67.7099254 24.8847955,68.2529639 25.4638864,68.2730303 C26.3530455,68.3133187 27.4697045,67.2068644 27.4697045,64.873557 C27.4697045,62.2387862 25.7325909,60.2271641 22.5273864,60.2271641 C19.3427045,60.2271641 16.5923409,62.6208264 16.5923409,66.4827613 C16.5923409,69.8621682 18.7842955,71.752925 21.8655682,71.752925 C22.9201818,71.752925 24.0576818,71.5317274 24.8847955,71.1293097 L25.2363864,72.2757414 Z M23.4165455,63.9683892 C23.2510909,63.9281008 23.0235909,63.8878124 22.7754091,63.8878124 C21.4105682,63.8878124 20.3351136,65.1952423 20.3351136,66.7439362 C20.3351136,67.5084832 20.6867045,67.9911668 21.3485227,67.9911668 C22.1342727,67.9911668 22.9408636,67.0458662 23.1063182,65.8792125 L23.4165455,63.9683892 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b5d4d780efe8049389985135c48215b5.svg";
export { ForwardRef as ReactComponent };